import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	top: 60px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	row-gap: 20px;

	opacity: 0;

	&.filter-enter {
		opacity: 0;
		transition: opacity 0.3s ease 0.3s;
	}

	&.filter-enter-active,
	&.filter-enter-done,
	&.filter-exit {
		opacity: 1;
		transition: opacity 0.3s ease 0.3s;
	}

	&.filter-exit-active {
		opacity: 0;
		transition: opacity 0.3s ease 5s;
	}

	img {
		user-select: none;
		pointer-events: none;
	}
`;

const StyledFilterNameContainer = styled.div`
	transition: opacity 0.3s ease;

	&.filter-name-enter {
		opacity: 0;
	}

	&.filter-name-enter-active,
	&.filter-name-enter-done,
	&.filter-name-exit {
		opacity: 1;
	}

	&.filter-name-exit-active {
		opacity: 0;
	}
`;

export { StyledContainer, StyledFilterNameContainer };
